




























































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import { maskMoney, timeout, timeoutDefault } from '@/utils/common'
import { RequestMessage, IRequestMessage } from '@/types/_'
import moment from 'moment'
import HistoricoSituacaoStore from '@/components/HistoricoSituacao/Store/HistoricoSituacaoStore'

@Component
export default class ComponentModalItensDoRepasse extends Vue {
  getRequestMessage: IRequestMessage = new RequestMessage()
  loadAlterarPontuacaoProfissional: boolean = false
  loadAlterarPrestador: boolean = false
  loadAlterarFuncao: boolean = false
  loadModalAlterarFuncao: boolean = false
  modalAlterarFuncao: boolean = false
  sel: any[] = []

  get modalItensDoRepasse() { return this.getFinanceiroStore.modal.itensDoRepasse }
  set modalItensDoRepasse(value: boolean) { this.getFinanceiroStore.setModal({ name: 'itensDoRepasse', value }) }

  loadHistorico: string = ''
  get loadingHistorico() { return this.loadHistorico }
  set loadingHistorico(value: string) { this.loadHistorico = value }

  confirmarExclusao(id: any) {
    const ids = [id]
    this.getFinanceiroStore.setMotivoExclusaoItemRepasseId(ids)
    this.getFinanceiroStore.setModal({ name: 'excluirItemRepasse', value: true })
  }

  confirmarExclusaoEmLote(ids: any) {
    this.getFinanceiroStore.setMotivoExclusaoItemRepasseId(ids)
    this.getFinanceiroStore.setModal({ name: 'excluirItemRepasse', value: true })
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get getPagina() {
    return this.getFinanceiroStore.pagina
  }

  set getPagina(value: number) {
    this.getFinanceiroStore.setPagina(value)
  }

  get statusGeracaoDeRepasse() {
    return this.getFinanceiroStore.statusGeracaoDeRepasse
  }

  get backofficeFinanceiroGeracaoRepasseItensHeaders() {
    return this.getFinanceiroStore.backofficeFinanceiroGeracaoRepasseItensHeaders
  }

  get geracaoDeRepassesItemsPrestador() {
    return this.getFinanceiroStore.geracaoDeRepassesItemsPrestador
  }

  get acoesGeracaoRepasse() {
    return this.getFinanceiroStore.acoesGeracaoRepasse
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get selected() { return this.sel }
  set selected(value: any) { this.sel = value }

  get loadingAlterarPontuacaoProfissional() {
    return this.loadAlterarPontuacaoProfissional
  }

  set loadingAlterarPontuacaoProfissional(value: boolean) {
    this.loadAlterarPontuacaoProfissional = value
  }

  get loadingAlterarPrestador() {
    return this.loadAlterarPrestador
  }

  set loadingAlterarPrestador(value: boolean) {
    this.loadAlterarPrestador = value
  }

  get loadingModalAlterarFuncao() {
    return this.loadModalAlterarFuncao
  }

  set loadingModalAlterarFuncao(value: boolean) {
    this.loadModalAlterarFuncao = value
  }

  get loadingAlterarFuncao() {
    return this.loadAlterarFuncao
  }

  set loadingAlterarFuncao(value: boolean) {
    this.loadAlterarFuncao = value
  }

  get showModalAlterarFuncao() {
    return this.modalAlterarFuncao
  }

  set showModalAlterarFuncao(value: boolean) {
    this.modalAlterarFuncao = value
  }

  get getTotal() {
    return this.getFinanceiroStore.totalItensPrestador || 0
  }

  get repasseLength() {
    return Math.ceil(this.getTotal / this.getFinanceiroStore.qtdPorPagina)
  }

  get funcao() {
    return this.getFinanceiroStore.funcoes
  }

  set funcao(value: any) {
    this.getFinanceiroStore.setFuncoes(value.key)
  }

  get apenasDivergentes() {
    return this.getFinanceiroStore.apenasDivergente
  }

  set apenasDivergentes(value: boolean) {
    this.getFinanceiroStore.setApenasDivergentes(value)
  }

  get alterarFuncao() {
    return this.getFinanceiroStore.alterarFuncao
  }

  set alterarFuncao(value: any) {
    this.getFinanceiroStore.setAlterarFuncao(value)
  }

  get funcoes() {
    return this.getFinanceiroStore.funcoesProfissionalExecutante
  }

  get getHistoricoSituacaoStore() {
    return getModule(HistoricoSituacaoStore, this.$store)
  }

  async showHistory(medicoProducaoProcedimentoId: string) {
    this.loadingHistorico = medicoProducaoProcedimentoId
    await this.getHistoricoSituacaoStore.getHistoricoGeracaoItens(medicoProducaoProcedimentoId)
    this.loadingHistorico = ''
  }

  async openModalAlterarFuncao(item: any) {
    this.loadingModalAlterarFuncao = true
    await timeoutDefault()
    const medicoProducaoProcedimentoId = [item.medicoProducaoProcedimentoId]
    this.getFinanceiroStore.setItemRepasse(medicoProducaoProcedimentoId)
    this.showModalAlterarFuncao = true
    this.loadingModalAlterarFuncao = false
  }

  async openModalAlterarFuncaoEmLote(item: any) {
    this.loadingModalAlterarFuncao = true
    await timeoutDefault()
    this.getFinanceiroStore.setItemRepasse(item)
    this.showModalAlterarFuncao = true
    this.loadingModalAlterarFuncao = false
  }

  closeModalAlterarFuncao() {
    this.showModalAlterarFuncao = false
  }

  async clearAdvancedFilters() {
    const id = this.getFinanceiroStore.idForLoadItensRepasse
    this.getFinanceiroStore.clearAdvancedFilters()
    this.getFinanceiroStore.setFilterOn(false)
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    await this.getFinanceiroStore.getGeracaoDeRepasseItensPrestador(id)
    EventBus.$emit('clearLoadingRequest')
  }

  async alterarFuncaoProfissional() {
    this.loadingAlterarFuncao = true
    const response = await this.getFinanceiroStore.alterarFuncaoGeracaoRepasse()
    if (response.success) {
      await this.filterFuncao()
      this.showModalAlterarFuncao = false
      EventBus.$emit('setSnackbar', { show: true, text: 'Função alterada com sucesso.', icon: 'check', color: '#4CAF50' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao alterar a função.', icon: 'warning', color: '#C62828' })
    }
    this.loadingAlterarFuncao = false
  }

  get drawer() {
    return this.getFinanceiroStore.filterDrawer
  }

  set drawer(value: boolean) {
    this.getFinanceiroStore.setFilterDrawer(value)
  }

  async showAdvancedFilters() {
    this.drawer = !this.drawer
  }

  maskMoneyUtil(value) {
    return maskMoney(value)
  }

  formatDateUtil(date: string) {
    if (['', null, undefined].includes(date)) return 'Não informado'
    return moment(date).format('DD/MM/YYYY')
  }

  formatDateTimeUtil(date: string) {
    if (['', null, undefined].includes(date)) return 'Não informado'
    return moment(date).format('DD/MM/YYYY HH:mm')
  }

  async selectFuncao(item: any) {
    this.funcao = item
    await this.$nextTick(() => {
      this.filterFuncao()
    })
  }

  async filterFuncao() {
    this.getFinanceiroStore.clearPagePagination()
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    const id = this.getFinanceiroStore.idForLoadItensRepasse
    await this.getFinanceiroStore.getGeracaoDeRepasseItensPrestador(id)
    EventBus.$emit('clearLoadingRequest')
  }

  async showModalAlterarPontuacaoProfissional(id: string) {
    this.loadingAlterarPontuacaoProfissional = true
    await timeout(500)
    this.getFinanceiroStore.setProfissionalPontuacao(id)
    this.getFinanceiroStore.getProfissionalPontuacao()
    this.getFinanceiroStore.setModal({ name: 'modalAlterarPontuacaoProfissional', value: true })
    this.loadingAlterarPontuacaoProfissional = false
  }

  async showModalAlterarPrestador(item: any) {
    this.loadingAlterarPrestador = true
    await timeout(500)
    this.getFinanceiroStore.setPrestadorId(item.prestadorRecebimentoId)
    this.getFinanceiroStore.setProfissionalRepasse(item.profissionalId)
    const medicoRecebimentoIds = [item.medicoRecebimentoId]
    this.getFinanceiroStore.setMedicoRecebimentoId(medicoRecebimentoIds)
    await this.getFinanceiroStore.getPrestadoresRepasse()
    this.getFinanceiroStore.setModal({ name: 'modalAlterarPrestador', value: true })
    this.loadingAlterarPrestador = false
  }

  async showModalAlterarPrestadorEmLote(ids: any, item: any) {
    this.loadingAlterarPrestador = true
    await timeout(500)
    this.getFinanceiroStore.setPrestadorId(item.prestadorRecebimentoId)
    this.getFinanceiroStore.setProfissionalRepasse(item.profissionalId)
    this.getFinanceiroStore.setMedicoRecebimentoId(ids)
    await this.getFinanceiroStore.getPrestadoresRepasse()
    this.getFinanceiroStore.setModal({ name: 'modalAlterarPrestador', value: true })
    this.loadingAlterarPrestador = false
  }

  async getResults(pagina: number) {
    const id = this.getFinanceiroStore.idForLoadItensRepasse
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    this.getPagina = pagina
    await this.getFinanceiroStore.getGeracaoDeRepasseItensPrestador(id)
    EventBus.$emit('clearLoadingRequest')
  }

  async queueAlterarFuncao() {
    const producaoProcedimentoIds = this.selected.map((item: any) => item.medicoProducaoProcedimentoId)
    this.openModalAlterarFuncaoEmLote(producaoProcedimentoIds)
  }

  async queueAlterarProfissional() {
    const medicoRecebimentoIds = this.selected.map((item: any) => item.medicoRecebimentoId)
    this.showModalAlterarPrestadorEmLote(medicoRecebimentoIds, this.selected[0])
  }

  async queueExcluirItens() {
    const ids = this.selected.map((item: any) => item.medicoRecebimentoId)
    this.confirmarExclusaoEmLote(ids)
  }

  async queueRecalculoRepasse() {
    const shouldSendEvent = this.selected.some((item: any) => !item.medicoProducaoProcedimentoId || item.medicoProducaoProcedimentoId === '00000000-0000-0000-0000-000000000000')

    const ids = this.selected.map((item: any) => item.medicoProducaoProcedimentoId)
    const medicoRecebimentoIds = this.selected.map((item: any) => item.medicoRecebimentoId)

    if (shouldSendEvent) {
      this.recalcularRepasse(medicoRecebimentoIds)
      this.getFinanceiroStore.setTemProcedimento(false)
    } else {
      this.recalcularRepasse(ids)
      this.getFinanceiroStore.setTemProcedimento(true)
    }
  }

  recalcularRepasse(ids: any) {
    this.getFinanceiroStore.setRecalculoIds(ids)
    this.getFinanceiroStore.setModal({ name: 'recalcularRepasse', value: true })
  }

  @Watch('apenasDivergentes')
  onChangeApenasDivergentes(value: boolean) {
    this.getFinanceiroStore.setApenasDivergentes(value)
    this.filterFuncao()
  }

  @Watch('modalItensDoRepasse')
  onChangeModalItensDoRepasse(value: boolean) {
    if (!value) {
      this.getFinanceiroStore.clearPagePagination()
      this.getFinanceiroStore.clearFuncoes()
      this.getFinanceiroStore.clearAdvancedFilters()
      this.selected = []
    }
  }

  @Watch('showModalAlterarFuncao')
  onChangeShowModalAlterarFuncao(value: boolean) {
    if (!value) {
      this.getFinanceiroStore.clearAlterarFuncao()
    }
  }
}
